/**
 * NDA management inside the super admin console.
 *
 * Same component the portal admin sees at /admin/upload-nda, mounted with the
 * super admin's API client and `canManage` — the portal copy is read-only.
 * Sharing the component rather than copying it means the two consoles can't
 * drift apart as the page grows.
 *
 * The backend guards in app/routers/nda.py are what actually permit this:
 * upload / publish / delete accept a super_admin token and nothing else, so a
 * portal admin who reaches the page anyway still gets a 403.
 *
 * `getAuthToken` is needed because opening a version's PDF is a direct fetch()
 * that bypasses the client, and the super admin's token lives in sessionStorage
 * under its own key rather than localStorage["token"].
 */
import AdminUploadNdaPage from "@/pages/AdminUploadNda";

import { getSuperAdminToken, superAdminApi } from "./session";

export default function SuperAdminNdaPage() {
  return (
    <AdminUploadNdaPage
      client={superAdminApi}
      canManage
      getAuthToken={getSuperAdminToken}
      enforcePortalGuard={false}
      title="NDA Management"
    />
  );
}
